import { create } from 'zustand';

const STORAGE_KEY = 'bsod.currentProjectId';

// Project public_id format — bare positive integer, no leading zeros.
// Matches `ProjectPublicId` from @bsod/contracts.
const PROJECT_PUBLIC_ID_RE = /^[1-9]\d*$/;

function loadInitial(): string | null {
  if (typeof window === 'undefined') return null;
  const raw = window.localStorage.getItem(STORAGE_KEY);
  // Defensive: a prior bug (since fixed) wrote event/case public_ids like
  // "2606-5" into this slot from non-project routes. If we see anything that
  // doesn't look like a project id now, drop it so global filters don't 400.
  if (raw && !PROJECT_PUBLIC_ID_RE.test(raw)) {
    window.localStorage.removeItem(STORAGE_KEY);
    return null;
  }
  return raw;
}

interface CurrentProjectState {
  currentProjectId: string | null;
  setCurrentProjectId: (id: string | null) => void;
}

export const useCurrentProjectStore = create<CurrentProjectState>((set) => ({
  currentProjectId: loadInitial(),
  setCurrentProjectId: (id) => {
    if (typeof window !== 'undefined') {
      if (id) window.localStorage.setItem(STORAGE_KEY, id);
      else window.localStorage.removeItem(STORAGE_KEY);
    }
    set({ currentProjectId: id });
  },
}));
